/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Subtitle_Processing_StatusInputs */

const en_iframe_remote_subtitle_processing_status = /** @type {(inputs: Iframe_Remote_Subtitle_Processing_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processing subtitle file...`)
};

const fr_iframe_remote_subtitle_processing_status = /** @type {(inputs: Iframe_Remote_Subtitle_Processing_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traitement du fichier de sous-titres...`)
};

const de_iframe_remote_subtitle_processing_status = /** @type {(inputs: Iframe_Remote_Subtitle_Processing_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertiteldatei wird verarbeitet...`)
};

const it_iframe_remote_subtitle_processing_status = /** @type {(inputs: Iframe_Remote_Subtitle_Processing_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elaborazione del file dei sottotitoli...`)
};

const ru_iframe_remote_subtitle_processing_status = /** @type {(inputs: Iframe_Remote_Subtitle_Processing_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обработка файла субтитров...`)
};

const es_iframe_remote_subtitle_processing_status = /** @type {(inputs: Iframe_Remote_Subtitle_Processing_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesando archivo de subtítulos...`)
};

const zh_cn2_iframe_remote_subtitle_processing_status = /** @type {(inputs: Iframe_Remote_Subtitle_Processing_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在处理字幕文件...`)
};

const ja_iframe_remote_subtitle_processing_status = /** @type {(inputs: Iframe_Remote_Subtitle_Processing_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕ファイルを処理しています...`)
};

const hi_iframe_remote_subtitle_processing_status = /** @type {(inputs: Iframe_Remote_Subtitle_Processing_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक फ़ाइल संसाधित हो रही है...`)
};

const pt_pt2_iframe_remote_subtitle_processing_status = /** @type {(inputs: Iframe_Remote_Subtitle_Processing_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processando arquivo de legenda...`)
};

/**
* | output |
* | --- |
* | "Processing subtitle file..." |
*
* @param {Iframe_Remote_Subtitle_Processing_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_subtitle_processing_status = /** @type {((inputs?: Iframe_Remote_Subtitle_Processing_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Subtitle_Processing_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_subtitle_processing_status(inputs)
	if (locale === "de") return de_iframe_remote_subtitle_processing_status(inputs)
	if (locale === "it") return it_iframe_remote_subtitle_processing_status(inputs)
	if (locale === "ru") return ru_iframe_remote_subtitle_processing_status(inputs)
	if (locale === "es") return es_iframe_remote_subtitle_processing_status(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_subtitle_processing_status(inputs)
	if (locale === "ja") return ja_iframe_remote_subtitle_processing_status(inputs)
	if (locale === "hi") return hi_iframe_remote_subtitle_processing_status(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_subtitle_processing_status(inputs)
	return en_iframe_remote_subtitle_processing_status(inputs)
});